import { PopoverComboboxOption } from '@/components/ui/custom/PopoverCombobox';
import { useDeskId } from '@/hooks/useDeskId';
import { useDepartments } from '@/modules/departments/hooks/useDepartments';

export const useDepartmentOptions = () => {
  const deskId = useDeskId();
  const { departments, listStatus } = useDepartments(deskId);
  const options: PopoverComboboxOption[] = (departments ?? []).map(({ department_id, name }) => ({
    value: department_id,
    label: name,
  }));
  return { options, isLoading: listStatus === 'pending' };
};
